import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CnpjService {
  private apiUrl = "/v1/cnpj/";

  constructor(private http: HttpClient) {}

  // Método para consultar o CNPJ
  consultarCnpj(cnpj: string): Observable<any> {
    const url = `${this.apiUrl}${cnpj}`;
    return this.http.get<any>(url); // Retorna um Observable com os dados
  }
}
